<template>

  <div class="position-absolute adp-dd-options adp-dd-options__cmps-tree d-flex flex-column" :class="{'adp-dd-options__2lvl': level}" v-if="isVisible">
    <template v-for="(competence, i) in competencies">
      <my-tree-filter-node :key="i" :competence="competence" v-on:mouseover="showNextLevel(competence)"
      v-on:my-node-change="onNodeChange($event, i)">
      </my-tree-filter-node>
    </template>

    <my-tree-filter :competencies="children" :is-visible="isChildrenVisible" :level="level+1"
                    v-on:my-change="onChildrenUpdate" v-if="children.length > 0">
    </my-tree-filter>
  </div>
</template>

<script>
import MyTreeFilterNode from './MyTreeFilterNode';


export default {
  name: 'MyTreeFilter',
  components: {
    'my-tree-filter-node': MyTreeFilterNode
  },
  props: {
    level: {
      type: Number,
      default: 0,
    },
    competencies: {
      required: true
    },
    isVisible: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      children: [],
      isChildrenVisible: false,
    }
  },
  watch: {
    competencies(newVal) {
      this.isChildrenVisible = false;
    }
  },
  methods: {
    onNodeChange(data, i) {
      let updateRecursive = (el) => {
        el.isChecked = data.isChecked;
        if (el.children && el.children.length > 0) {
          el.children = el.children.map(el => updateRecursive(el));
        }
        return el;
      };

      this.competencies[i].children = this.competencies[i].children.map(el => updateRecursive(el));
      this.fireMyChange(i);
    },
    fireMyChange(i) {
      let cntChecked = this.competencies.filter(cmp => cmp.isChecked);
      let cntIndeterminate = this.competencies.filter(cmp => cmp.isIndeterminate);
      let parentIsChecked = cntChecked.length === this.competencies.length;
      let parentIsIndeterminate = cntChecked.length > 0 && cntChecked.length < this.competencies.length || cntIndeterminate.length > 0;

      let data = {
        competence: this.competencies[i],
        isChecked: parentIsChecked,
        isIndeterminate: parentIsIndeterminate,
      }
      this.$emit('my-change', data);
    },
    onChildrenUpdate(data) {
      // console.log(data.isChecked, data.isIndeterminate, this.level);
      const index = this.competencies.findIndex(item => {
        return item.children.findIndex(item => {
          return item.id === data.competence.id;
        }) > -1;
      });
      this.competencies[index].isChecked = data.isChecked;
      this.competencies[index].isIndeterminate = data.isIndeterminate;

      this.fireMyChange(index);

      if (this.level === 0) {
        this.$emit('root-change', this.competencies);
      }
    },
    showNextLevel(competence) {
      if (competence.children) {
        this.children = competence.children;
        this.isChildrenVisible = true;
      }
    },
  },
}
</script>

<style scoped>

</style>
